"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleWrapper = exports.StyleImg = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const StyleWrapper = exports.StyleWrapper = _styledComponents.default.div.withConfig({
  displayName: "StyleWrapper",
  componentId: "sc-wzen6a-0"
})(["position:relative;"]);
const StyleImg = exports.StyleImg = _styledComponents.default.img.withConfig({
  displayName: "StyleImg",
  componentId: "sc-wzen6a-1"
})(["width:18px;height:18px;transform:translate(4px,4px);opacity:1;transition:opacity 0.3s;cursor:pointer;"]);